import React from "react";
import {ClockCircleOutlined, FieldTimeOutlined, HistoryOutlined} from "@ant-design/icons";
import {ShiftsNavTab, ShiftsTabRow} from "../styles/CustomerShiftsPage.styles";

const ShiftsNavigationButtons = ({tabKey, changeTab, shiftCounts}) => {
    return (
        <ShiftsTabRow className="navigation-buttons-row">
            <ShiftsNavTab
                isActive={tabKey === "activeShifts"}
                onClick={() => changeTab("activeShifts")}
                className="navigation-button"
            >
                <div>
                    <ClockCircleOutlined />
                    <div>{shiftCounts?.activeCount || 0}</div>
                    <div>Aktif Vardiyalar</div>
                </div>
            </ShiftsNavTab>
            <ShiftsNavTab
                isActive={tabKey === "futureShifts"}
                onClick={() => changeTab("futureShifts")}
                className="navigation-button"
            >
                <div>
                    <HistoryOutlined />
                    <div>{shiftCounts?.plannedCount || 0}</div>
                    <div>Planlanan Vardiyalar</div>
                </div>
            </ShiftsNavTab>
            <ShiftsNavTab
                isActive={tabKey === "pastShifts"}
                onClick={() => changeTab("pastShifts")}
                className="navigation-button"
            >
                <div>
                    <FieldTimeOutlined />
                    <div>{shiftCounts?.completedCount || 0}</div>
                    <div>Tamamlanan Vardiyalar</div>
                </div>
            </ShiftsNavTab>
        </ShiftsTabRow>
    );
};

export default ShiftsNavigationButtons;
